<template>
  <div class="relative w-full md:w-auto">
    <SearchIcon class="absolute left-0 top-0 bottom-0 h-full ml-5 opacity-50"/>
    <input dusk="search-input" :class="inputClasses" class="transition duration-150 ease-in-out rounded-full border border-transparent focus:outline-none pl-12 pr-4 py-2 focus:border-yankFire hover:border-payneMiddle"
      type="search"
      placeholder="Search"
      @keydown.enter="search"
    >
  </div>
</template>
<script>
import SearchIcon from "@/components/svg/SearchIcon"

export default {
  name: 'SearchInput',
  components: {SearchIcon},
  props:{
    inputClasses:String,
  },

  methods: {
    search(event) {
      this.$emit('search', event.target.value)
    }
  }
}
</script>
